import { setCookie, getCookie } from './cookies';

const $body = $('body');
const $recentHolder = $('.section-product-misc--related .list-products');
let visitedPages = [];

const productTemplate = `
    <div class="product-item">
        <div class="product-item__image">
            <a href="{{href}}" class="product-item__link">
                <img class="product-item__image" src="{{src}}" >
            </a>

            {{badge}}
        </div><!-- /.product-item__image -->

        <h3 class="product-item__title">
            <a href="{{href}}">{{title}}</a>
        </h3>

        <p class="product-item__price price">
            {{money}}
        </p>
    </div>
`;

function getProduct(arr) {
    arr.map(item => {
        $.ajax({
            url: `${item}.js`,
            dataType: 'json'
        }).done(response => {
            let markup = productTemplate;

            markup = markup.replace('{{title}}', response.title);
            markup = markup.replace('{{href}}', item);
            markup = markup.replace('{{src}}', response.featured_image);

            let itemPrice = '';

            if (response.compare_at_price) {
                itemPrice = `<del class="price__amount">
                                    <span class="money">
                                        ${Shopify.theme.locale.products.product.price_before} ${Shopify.formatMoney(
                    response.compare_at_price
                )}
                                    </span>
                                </del>

                                <ins class="price__amount">
                                    <span class="money">
                                        ${Shopify.theme.locale.products.product.price_now} ${Shopify.formatMoney(response.price)}
                                    </span>
                                </ins>
                `;
            } else {
                itemPrice = `<span class="money">${Shopify.formatMoney(response.price)}</span>`;
            }

            markup = markup.replace('{{money}}', itemPrice);

            // Add Badge
            let itemBadge = '';

            if (response.tags != '') {
                for (var i = 0; i < response.tags.length; i++) {
                    if (response.tags[i].indexOf('badge:') !== -1) {
                        itemBadge = '<span class="product-item__badge">';
                        itemBadge += response.tags[i].replace('badge: ', '');
                        itemBadge = itemBadge.replace('badge:', '');
                        itemBadge += '</span>';

                        break;
                    }
                }
            }

            markup = markup.replace(/{{badge}}/g, itemBadge);

            $recentHolder.append(markup);
        });
    });
}

if ($body.hasClass('template-product')) {
    let productURL = window.location.pathname;
    let productHandle = productURL.split('/products/')[1];

    if (getCookie('visitedPages')) {
        visitedPages = getCookie('visitedPages').split(',');
        $recentHolder.empty();
        getProduct(visitedPages);
    }

    if (visitedPages.indexOf(productHandle) < 0) {
        visitedPages.push(productHandle);
    }

    let visitedPagesLen = visitedPages.length;
    if (visitedPagesLen > 5) {
        visitedPages = visitedPages.slice(visitedPagesLen - 5, visitedPagesLen);
    }

    setCookie('visitedPages', visitedPages.join(','), 99);
}
